import { exportModules } from '@/assets/js/__utils__/file';

// console.log("file")
let requireFiles = require.context('@/config/config', false, /\.js$/);
// console.log(requireFiles)
const modules = exportModules(requireFiles, true, true)

export default modules;
